<template>
    <section class="questionwrapper">
      <div class="helper-holder">
        <!--<p class="coloranswer" v-bind:style="{ backgroundColor: answerThreeC }"><span class="largetext" v-bind:style="{ color: answerThreeC }">{{ answerThreeC }}</span></p><p>is the color of success</p>-->
        <p class="coloranswer" v-bind:style="{ backgroundColor: answerThreeC.colorInput, color: answerThreeC.textColor }"><span class="largetext">{{ answerThreeC.colorInput }}</span></p><p>is the color of success</p>

        <!--<p>{{ hexToRGB(answerThreeC) }}</p>-->

      </div>
    </section>
</template>

<script>
export default {
  props: {
    answerThreeC: {
      type: Object // String
    }
  }

};
</script>

<style>

</style>
